/**
 * Types de financeurs — source unique de vérité.
 *
 * Pour ajouter un nouveau type :
 *   1. Ajouter une ligne ici  { key: 'mon_type', label: 'Mon Type' }
 *   2. C'est tout — les trois dérivés ci-dessous se mettent à jour automatiquement.
 */
export const FINANCEUR_TYPES = [
  { key: 'client',         label: 'Client'         },
  { key: 'opco',           label: 'OPCO'           },
  { key: 'france_travail', label: 'France Travail' },
  { key: 'region',         label: 'Région'         },
  { key: 'cpf',            label: 'CPF'            },
  { key: 'autre',          label: 'Autre'          },
];

// { client: 'Client', opco: 'OPCO', ... }
// Utilisé dans SessionDetail pour afficher le libellé d'un type_financeur
export const TYPE_FINANCEUR_LABELS = Object.fromEntries(
  FINANCEUR_TYPES.map(t => [t.key, t.label])
);

// { 'Client': 'client', 'OPCO': 'opco', ... }
// Utilisé dans SessionDetail pour convertir le type d'un organisme référentiel → clé interne
export const ORGANISME_TYPE_MAP = Object.fromEntries(
  FINANCEUR_TYPES.map(t => [t.label, t.key])
);

// ['Client', 'OPCO', 'France Travail', ...]
// Utilisé dans Parametres pour peupler le <select> du référentiel organismes
export const TYPE_OPTIONS = FINANCEUR_TYPES.map(t => t.label);
